import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A Suspense boundary whose suspended children count as one pending load, so a reader that waits
 * for the loader to settle, such as a capture, waits for a lazy chunk too. Its fallback draws
 * nothing: the R3F reconciler's tree has no host for a `<div>`.
 */
import { Suspense } from 'react';
import { usePendingWhile } from './usePendingWhile';
function PendingFallback() {
    usePendingWhile(true);
    return null;
}
export function PendingSuspense({ children }) {
    return _jsx(Suspense, { fallback: _jsx(PendingFallback, {}), children: children });
}
//# sourceMappingURL=PendingSuspense.js.map